// jQuery Cookie
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function o(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function t(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(c," ")),u.json?JSON.parse(e):e}catch(n){}}function r(n,o){var i=u.raw?n:t(n);return e.isFunction(o)?o(i):i}var c=/\+/g,u=e.cookie=function(t,c,s){if(arguments.length>1&&!e.isFunction(c)){if(s=e.extend({},u.defaults,s),"number"==typeof s.expires){var a=s.expires,d=s.expires=new Date;d.setMilliseconds(d.getMilliseconds()+864e5*a)}return document.cookie=[n(t),"=",i(c),s.expires?"; expires="+s.expires.toUTCString():"",s.path?"; path="+s.path:"",s.domain?"; domain="+s.domain:"",s.secure?"; secure":""].join("")}for(var f=t?void 0:{},p=document.cookie?document.cookie.split("; "):[],l=0,m=p.length;m>l;l++){var x=p[l].split("="),g=o(x.shift()),j=x.join("=");if(t===g){f=r(j,c);break}t||void 0===(j=r(j))||(f[g]=j)}return f};u.defaults={},e.removeCookie=function(n,o){return e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n)}});


/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});


/*! lazysizes - v4.1.4 */
!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}(window,function(a,b){"use strict";if(b.getElementsByClassName){var c,d,e=b.documentElement,f=a.Date,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h],k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,d,e,f,g){var h=b.createEvent("Event");return e||(e={}),e.instance=c,h.initEvent(d,!f,!g),h.detail=e,a.dispatchEvent(h),h},w=function(b,c){var e;!g&&(e=a.picturefill||d.pf)?(c&&c.src&&!b[i]("srcset")&&b.setAttribute("srcset",c.src),e({reevaluate:!0,elements:[b]})):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<d.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,c=0,e=d.throttleDelay,g=d.ricTimeout,h=function(){b=!1,c=f.now(),a()},i=m&&g>49?function(){m(h,{timeout:g}),g!==d.ricTimeout&&(g=d.ricTimeout)}:A(function(){k(h)},!0);return function(a){var d;(a=a===!0)&&(g=33),b||(b=!0,d=e-(f.now()-c),0>d&&(d=0),a||9>d?i():k(i,d))}},C=function(a){var b,c,d=99,e=function(){b=null,a()},g=function(){var a=f.now()-c;d>a?k(g,d-a):(m||e)(e)};return function(){c=f.now(),b||(b=k(g,d))}};!function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:0,throttleDelay:125};d=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in d||(d[b]=c[b]);a.lazySizesConfig=d,k(function(){d.init&&F()})}();var D=function(){var g,l,m,o,p,y,D,F,G,H,I,J,K,L,M=/^img$/i,N=/^iframe$/i,O="onscroll"in a&&!/(gle|ing)bot/.test(navigator.userAgent),P=0,Q=0,R=0,S=-1,T=function(a){R--,a&&a.target&&u(a.target,T),(!a||0>R||!a.target)&&(R=0)},U=function(a,c){var d,f=a,g="hidden"==x(b.body,"visibility")||"hidden"!=x(a.parentNode,"visibility")&&"hidden"!=x(a,"visibility");for(F-=c,I+=c,G-=c,H+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=e;)g=(x(f,"opacity")||1)>0,g&&"visible"!=x(f,"overflow")&&(d=f.getBoundingClientRect(),g=H>d.left&&G<d.right&&I>d.top-1&&F<d.bottom+1);return g},V=function(){var a,f,h,j,k,m,n,p,q,r=c.elements;if((o=d.loadMode)&&8>R&&(a=r.length)){f=0,S++,null==K&&("expand"in d||(d.expand=e.clientHeight>500&&e.clientWidth>500?500:370),J=d.expand,K=J*d.expFactor),K>Q&&1>R&&S>2&&o>2&&!b.hidden?(Q=K,S=0):Q=o>1&&S>1&&6>R?J:P;for(;a>f;f++)if(r[f]&&!r[f]._lazyRace)if(O)if((p=r[f][i]("data-expand"))&&(m=1*p)||(m=Q),q!==m&&(y=innerWidth+m*L,D=innerHeight+m,n=-1*m,q=m),h=r[f].getBoundingClientRect(),(I=h.bottom)>=n&&(F=h.top)<=D&&(H=h.right)>=n*L&&(G=h.left)<=y&&(I||H||G||F)&&(d.loadHidden||"hidden"!=x(r[f],"visibility"))&&(l&&3>R&&!p&&(3>o||4>S)||U(r[f],m))){if(ba(r[f]),k=!0,R>9)break}else!k&&l&&!j&&4>R&&4>S&&o>2&&(g[0]||d.preloadAfterLoad)&&(g[0]||!p&&(I||H||G||F||"auto"!=r[f][i](d.sizesAttr)))&&(j=g[0]||r[f]);else ba(r[f]);j&&!k&&ba(j)}},W=B(V),X=function(a){s(a.target,d.loadedClass),t(a.target,d.loadingClass),u(a.target,Z),v(a.target,"lazyloaded")},Y=A(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,c=a[i](d.srcsetAttr);(b=d.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},aa=A(function(a,b,c,e,f){var g,h,j,l,o,p;(o=v(a,"lazybeforeunveil",b)).defaultPrevented||(e&&(c?s(a,d.autosizesClass):a.setAttribute("sizes",e)),h=a[i](d.srcsetAttr),g=a[i](d.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),o={target:a},p&&(u(a,T,!0),clearTimeout(m),m=k(T,2500),s(a,d.loadingClass),u(a,Z,!0)),l&&q.call(j.getElementsByTagName("source"),_),h?a.setAttribute("srcset",h):g&&!l&&(N.test(a.nodeName)?$(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,d.lazyClass),z(function(){(!p||a.complete&&a.naturalWidth>1)&&(p?T(o):R--,X(o))},!0)}),ba=function(a){var b,c=M.test(a.nodeName),e=c&&(a[i](d.sizesAttr)||a[i]("sizes")),f="auto"==e;(!f&&l||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,d.errorClass)||!r(a,d.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,R++,aa(a,b,f,e,c))},ca=function(){if(!l){if(f.now()-p<999)return void k(ca,999);var a=C(function(){d.loadMode=3,W()});l=!0,d.loadMode=3,W(),j("scroll",function(){3==d.loadMode&&(d.loadMode=2),a()},!0)}};return{_:function(){p=f.now(),c.elements=b.getElementsByClassName(d.lazyClass),g=b.getElementsByClassName(d.lazyClass+" "+d.preloadClass),L=d.hFac,j("scroll",W,!0),j("resize",W,!0),a.MutationObserver?new MutationObserver(W).observe(e,{childList:!0,subtree:!0,attributes:!0}):(e[h]("DOMNodeInserted",W,!0),e[h]("DOMAttrModified",W,!0),setInterval(W,999)),j("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(a){b[h](a,W,!0)}),/d$|^c/.test(b.readyState)?ca():(j("load",ca),b[h]("DOMContentLoaded",W),k(ca,2e4)),c.elements.length?(V(),z._lsFlush()):W()},checkElems:W,unveil:ba}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;g>f;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),e=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width,d&&d!==a._lazysizesWidth&&c(a,f,e,d)))},f=function(){var b,c=a.length;if(c)for(b=0;c>b;b++)e(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(d.autosizesClass),j("resize",g)},checkElems:g,updateElem:e}}(),F=function(){F.i||(F.i=!0,E._(),D._())};return c={cfg:d,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}}});


/**
 * END OF VENDOR SCRIPTS
 */


var DEBUG = false;

// Expand Shopify JS API
Shopify = Shopify || {};

Shopify.queue = [];

Shopify.moveAlong = function(callback) {
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
    Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong.bind(null, callback));
  }
  else {
    lemonade.renderCart(callback);
  }
};

window.theme = window.theme || {};

// Global selectors and values
theme.cacheSelectors = function(){

	theme.cache = {
		$win: $(window),
		$body: $('body'),
		$header: $('#site-header'),
		$mobileMenu: $('#mobile-menu'),
		$flyout: $('#mini-cart'),
		$flyout_items: $('#mini-cart .cart-body'),
		$addCustomProduct: $('.add-custom-product, [data-add-to-cart]'),
		state: null,
		mobile_break: 767,
		speed: 250
	};
};

// Kick off functions
theme.init = function(){
	theme.cacheSelectors();
	theme.fastClick();
  theme.fastClick1();
	theme.windowEvents();
	theme.windowState();
	theme.matchHeight();
	theme.fitVids();
	theme.utilityToggle();
	theme.megaMenu();
	theme.openMobileMenu();
	//theme.closeMobileClick();
	theme.accordion();
	theme.popup();
	theme.slick();
	theme.backToTop();
	theme.productHover();
	theme.ajaxMailchimp();
	theme.productSwap();
	theme.customSelects();
	theme.panels();
	theme.configurator();
  theme.configuratorV2();
	theme.instagram();
	theme.chat();
	theme.mediaBlock();
	theme.collectionAnchors();
};

// Remove click delay
theme.fastClick = function(){
	FastClick.attach(document.body);
};

theme.fastClick1 = function(){

};

// Return window width
theme.windowWidth = function(){
  return theme.cache.$win.width();
};

// Return window scrollTop
theme.windowScrollTop = function(){
	return theme.cache.$win.scrollTop();
};

// Window events
theme.windowEvents = function(){

	theme.cache.$win.on({
		load: function(){

		},
		resize: function(){
			theme.windowWidth();
			theme.windowState();
			theme.initHorizMenus();
		},
		scroll: function(){
			theme.windowScrollTop();

		}
	});

};

// Fire functions when crossing desktop/mobile threshold
theme.windowState = function(){

	winState();

	function winState() {
  	win_width = theme.windowWidth();
		if(win_width > theme.cache.mobile_break){
			if (theme.cache.state != 'desktop') {
				theme.cache.state = 'desktop';
				changedstate(theme.cache.state);
			};
		} else {
			if (theme.cache.state != 'mobile') {
				theme.cache.state = 'mobile';
				changedstate(theme.cache.state);
			};
		}
	}

	function changedstate(mystate){

		var $mobile_slick = $('.mobile-slick');

	  if(mystate == 'desktop'){
			theme.horizontalMenus();
			if($mobile_slick.hasClass('slick-initialized')){
				$mobile_slick.slick('unslick');
			}
	  } else {
		  theme.horizontalMenus();
		  $mobile_slick.slick();
	  }
	}


};

// Body no scroll
theme.noScroll = function(){
	theme.cache.$body.addClass('no-scroll');
};

// Body yes scroll
theme.yesScroll = function(){
	theme.cache.$body.removeClass('no-scroll');
};

// Match Height
theme.matchHeight = function(){
	$('.mh').matchHeight();
};

// Fitvids
theme.fitVids = function(){
	$('.video-wrapper').fitVids();
};

// Utility toggle
theme.utilityToggle = function(){
	var $utility_trigger = $('.utility-trigger');

	$utility_trigger.click(function(){
		$me = $(this);

		$me.siblings().removeClass('active');
		$('.utility-item').removeClass('show');
      //$(".defaultAddToCart").removeClass("disabled");
      //$('.defaultAddToCart').prop('disabled', false);

		if($me.hasClass('active')){
			$me.removeClass('active');
			me_item = $me.data('header-utility');
			$('#'+me_item).removeClass('show');
          if(me_item=="mini-cart"){
          $('body').removeClass('lockscrl');
          }
		} else {
			$me.addClass('active orange');
			me_item = $me.data('header-utility');
			$('#'+me_item).addClass('show');
          if(me_item=="mini-cart"){
          $('body').addClass('lockscrl');
          }
			if (me_item == 'global-search') {
				setTimeout(function(){
					$('#global-search input').focus();
				}, 500);
			}
		}
	});
};

// Chat trigger
theme.chat = function(){
	$('.chat-trigger').click(function(){
		$('#livechat-full-view').contents().find('#full-view-button').trigger( "click" );
	});
};

// Mega Menus
theme.megaMenu = function(){

	var $mega_trigger = $('.site-nav').find('li'),
	    speed = 250,
	    timer;

	function closeShop(){
		$me_panel = $('#'+me_data);
		if($me_panel.hasClass('mega-panel')){
			$me_panel.siblings('.mega-panel').hide();
		} else {
			$('.mega-panel').fadeOut();
		}
		timer = setTimeout(function(){
			$me.removeClass('activated');
			$me_panel.fadeOut(speed);
		}, 100);
	}

	$mega_trigger.on({
		mouseenter: function(){
			$me = $(this);
			me_data = $me.data('mega-trigger');
			$me_panel = $('#'+me_data);
			$me.stop();
			$me.addClass('activated').siblings().removeClass('activated');
			clearTimeout(timer);
			if($me_panel.length > 0){
				$me_panel.fadeIn(speed).siblings('.mega-panel').hide();
			} else {
				closeShop();
			}
		},
		mouseleave: function(){
			$me = $(this);
			$me.stop();
			closeShop();
		}
	});

	$('.mega-panel').on({
		mouseenter: function(){
			clearTimeout(timer);
		},
		mouseleave: function(){
			closeShop();
		}
	});

};

// Open the mobile menu
theme.openMobileMenu = function(){
	$('#btn-mobile-menu').click(function(){
		$me = $(this);
		if($me.hasClass('open')){
			$me.removeClass('open');
			theme.cache.$mobileMenu.removeClass('show-menu');
			theme.yesScroll();
		} else {
			$me.addClass('open');
			theme.cache.$mobileMenu.addClass('show-menu');
			theme.noScroll();
		}
	});
};

// Close the mobile menu
/*
theme.closeMobileMenu = function(){
	if(theme.cache.$mobileMenu.hasClass('show-menu')){
		theme.cache.$mobileMenu.removeClass('show-menu');
		theme.yesScroll();
	}
};
*/

// Close mobile menu click event
theme.closeMobileClick = function(){
	$('.close-mobile').click(theme.closeMobileMenu);
};

// Content accordions
theme.accordion = function(){

  var $accTrigger = $('.acc-trigger'),
      $acc = $('.acc-content');

  // accordian content
  $accTrigger.click(function(){
    var $me = $(this),
        $content = $me.next('.acc-content');

    $acc.slideUp();
    if($me.hasClass('open')){
      $me.removeClass('open');
      return false;
    }
    $accTrigger.removeClass('open');
    $me.addClass('open');
    $content.slideToggle();
  });

};

/* Popup Newsletter */
theme.popup = function(){

	function newsletterPopup(){
    $.fancybox.open([{
	    width: 700,
	    height: 700
	    //href: '#newsletter-popup'
    }], {
	    padding: 50
    });
	}

  if (typeof $.cookie('newsletter-modal') === 'undefined') {
    $.cookie('newsletter-modal', '1', { expires: 30, path: '/' });
    setTimeout(function(){
			newsletterPopup();
		}, 3000);
  }

  $('.newsletter-trigger').click(function(){
	  newsletterPopup();
  });

};

// Slick init
theme.slick = function(){

	var $slick = $('.slick');

	if($slick.length > 0){
		$slick.slick();
	}

};

// Back to top
theme.backToTop = function(){

	$('.back-to-top').click(function(){
		theme.cache.$body.animate({'scrollTop': 0});
	});

};

// Product grid hover photo
theme.productHover = function(){

	var speed = 200;

	$('.grid-item-image').on({
		mouseenter: function(){
			$me = $(this);
			$me_hover_img = $me.find('.hover-img');

			if($me_hover_img.length > 0){
				$me_hover_img.fadeIn(speed);
				$me.find('img').first().fadeOut(speed);
			}
		},
		mouseleave: function(){
			$me = $(this);
			$me_hover_img = $me.find('.hover-img');

			if($me_hover_img.length > 0){
				$me.find('.hover-img').fadeOut(speed);
				$me.find('img').first().fadeIn(speed);
			}
		}
	});

};

// Mailchimp Ajax submit
theme.ajaxMailchimp = function(){

  var $form = $('.contact-form'),
      message;

  $form.find('input[type="submit"]').on('click', function(event) {
    if(event) event.preventDefault();
    register($form);
  });

	function register($form) {
	  $.ajax({
	    type: $form.attr('method'),
	    url: $form.attr('action'),
	    data: $form.serialize(),
	    cache       : false,
	    dataType    : 'json',
	    contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
					message = data.msg || "Translation missing: en.general.newsletter_form.newsletter_form_fail";
					if (data.msg && data.msg.indexOf('already subscribed') >= 0) {
						message = 'You’re already subscribed. Thank you.';
					}
          $('.success').html(message).fadeIn();
        } else {
          message = "Translation missing: en.general.newsletter_form.newsletter_form_success";
          $('.success').html(message).fadeIn();
        }
      }
	  });
	}
};

// Product thumb swap
theme.productSwap = function(){

	var $productFeatured = $('#product-featured');

	$('#swatch-box').find('.swatch').click(function(){
		var $me = $(this);
		var new_pic = $me.data('variant-img');

		$('#product-featured').find('img.cbb-loupe1').attr('src', new_pic);
	});

var bcd2=0;
	$('.product-thumbs-item').click(function(e){
      bcd2=bcd2+1;
		e.preventDefault();
      $(".prod-img-container").show();
      $(".prod-video-container").hide();
		var $me = $(this);
		var new_pic = $me.attr('href');
		var $featuredImg = $('#product-featured').find('img.cbb-loupe1');

		$('.product-thumbs-item').removeClass('active');
		$me.addClass('active');

		if ($featuredImg.attr('src') === new_pic) return;

		var timeout = setTimeout(function() {
			$productFeatured.addClass('loading');
		}, 300);

		$featuredImg.stop().animate({
			display: 'none'
		},
		function() {
			var $self = $(this);
			$self.on('load', function() {
				// clearTimeout(timeout);
				$productFeatured.removeClass('loading');
				$self.stop().animate({ display: 'block' });
			});
			$self.attr('src', new_pic);
          console.log($self.attr('class'));
		});
      if($(window).outerWidth() < 782 && $(".template-product ")[0]){
        if(bcd2>1){
        var bcd1=$me.attr("data-slick-index");
$(".newimggallery").slick('slickGoTo', bcd1);         
      }
      }
	});

};

// Product custom selects
theme.customSelects = function(){
	var $selectWrap = $('.selector-wrapper'),
			$prod_variants = $('.single-option-selector'),
			$label = $(".selectorContainer").find('label'),
	    $options = $selectWrap.find('option'),
	    $dummy = $('<ul class="swatch-wrap dummy-select"></ul>'),
        $dummy1 = $('<ul class="swatch-wrap dummy-select"></ul>'),
		$selection = $('<span class="label">'+$label.text()+'</span>'),
		$thumbs = $('.product-thumbs-item'),
        $thumbs1 = $('.product-thumbs-item1'),
		defaultThumb,
        defaultThumb1;

	// wipe clean the selector on each color change
	$selectWrap.find('ul, .selection').remove();

	// build options in dummy select dropdown with data-attributes derived from real select
  if ($(".jstthatid")[0]){
    $selectWrap.each(function(index){
      var thsopt=$(this);
    var indxprnt=index;
     
      
    thsopt.find($options).each(function(i, el){
    $el = $(el);
    var str = $el.val();
		str = str.replace(/\s/g, "-");
       
     
      if(i == 0){
        if(str.indexOf("{#") >= 0){
          var colorcode = str.substring(str.indexOf("{#")+1, str.indexOf("{#") + 8);
          $dummy.append('<li style="background-color:' + colorcode + ';" class="swatch '+str+' active" data-val="'+$el.val()+'">'+$el.text()+'</li>');
          defaultThumb = $el.val();
        }
        else{
          if(indxprnt==0)
          {
          $dummy.append('<li class="hereis swatch '+str+' active" data-val="'+$el.val()+'">'+$el.text()+'</li>');
          }
          else{
           $dummy1.append('<li class="hereis swatch '+str+' active" data-val="'+$el.val()+'">'+$el.text()+'</li>');
          }
          defaultThumb = $el.val();
        }
      } else {
        if(str.indexOf("{#") >= 0){
          var colorcode = str.substring(str.indexOf("{#")+1, str.indexOf("{#") + 8);
          $dummy.append('<li style="background-color:' + colorcode + ';" class=" swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>');
        }
        else{
          if(indxprnt==0)
          {
            
          $dummy.append('<li class="swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>');
          }
          else{
          $dummy1.append('<li class="swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>');
          }}
      }
  });
  });
  }
  else{
  $options.each(function(i, el){
    $el = $(el);
    var str = $el.val();
     var gtvriantid;
   
     $(".detail-box.productorig #productSelect option").each(function(){
        var gtvartitle=$(this).text();
      
        if(gtvartitle.includes(str)){
        gtvriantid=$(this).attr("varimg");
        
        }
      });
		str = str.replace(/\s/g, "-");
     if(i == 0){
        if(str.indexOf("{#") >= 0){
          var colorcode = str.substring(str.indexOf("{#")+1, str.indexOf("{#") + 8);
          $dummy.append('<li style="background-image: url('+gtvriantid+'); background-color:' + colorcode + ';" class="swatch '+str+' active" data-val="'+$el.val()+'">'+$el.text()+'</li>');
          defaultThumb = $el.val();
        }
        else{
          $dummy.append('<li style="background-image: url('+gtvriantid+');" class="swatch '+str+' active" data-val="'+$el.val()+'">'+$el.text()+'</li>');
          defaultThumb = $el.val();
        }
      } else {
        if(str.indexOf("{#") >= 0){
          var colorcode = str.substring(str.indexOf("{#")+1, str.indexOf("{#") + 8);
          $dummy.append('<li style="background-image: url('+gtvriantid+'); background-color:' + colorcode + ';" class="swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>');
        }
        else{
          $dummy.append('<li style="background-image: url('+gtvriantid+');" class="swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>');
        }
      }
      // if(i == 0){
      //   if(str.indexOf("{#") >= 0){
      //     var colorcode = str.substring(str.indexOf("{#")+1, str.indexOf("{#") + 8);
      //     $dummy.append('<li class="swatch '+str+' active" data-val="'+$el.val()+'">'+$el.text()+'</li>');
      //     defaultThumb = $el.val();
      //   }
      //   else{
      //     $dummy.append('<li class="swatch '+str+' active" data-val="'+$el.val()+'">'+$el.text()+'</li>');
      //     defaultThumb = $el.val();
      //   }
      // } else {
      //   if(str.indexOf("{#") >= 0){
      //     var colorcode = str.substring(str.indexOf("{#")+1, str.indexOf("{#") + 8);
      //     $dummy.append('<li class="swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>');
      //   }
      //   else{
      //     $dummy.append('<li class="swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>');
      //   }
      // }

  });
  }
  
  $selectWrap.prepend($selection);
  if ($(".jstthatid")[0]){
    $('.selector-wrapper:eq(0)').prepend($dummy);
    $('.selector-wrapper:eq(1)').prepend($dummy1);
  }
  else{
  $selectWrap.prepend($dummy);
  }
  $label.add($prod_variants).hide();
  //$selectWrap.find('span').hide();
  //$selectWrap.find('label').show();
  if ($(".jstthatid")[0]){
    var abcd=$(".selector-wrapper:eq(0)").find('label').html();
    var abcd1=$(".selector-wrapper:eq(1)").find('label').html();
    var abcd2=$(".selector-wrapper:eq(0)").find(".swatch.active").text();
    var abcd3=$(".selector-wrapper:eq(1)").find(".swatch.active").text();
    var abcd11='<b>'+abcd+': </b><span>'+abcd2+'</span>';
    var abcd111='<b>'+abcd1+': </b><span>'+abcd3+'</span>';
    $(".selector-wrapper:eq(0)").find('span').html(abcd11);
     $(".selector-wrapper:eq(1)").find('span').html(abcd111);
  $selectWrap.find('span').show();
  $selectWrap.find('label').hide();
  }
  else{
  $selectWrap.find('span').html($selectWrap.find('label').html());
  $selectWrap.find('span').show();
  $selectWrap.find('label').hide();
  }
 
  if ($(".jstthatid")[0]){
//   defaultThumb1=$("#product-featured .prod-img-container img").attr("alt");
  var gtit3=$("#product-featured .prod-img-container img").attr("alt").split('|');
    defaultThumb1=gtit3[0].trim();
    console.log(defaultThumb1);
    handleThumbs(defaultThumb1);
//      console.log(defaultThumb1);
  }
  else{
    handleThumbs(defaultThumb);}

  // click evens on variant select
  $('body').on('click', '.dummy-select li', function(){
	$me = $(this);

	if(!$me.hasClass('active')) {
		$me.addClass('active').siblings('.swatch').removeClass('active');
	    value = $me.data('val');
      console.log(value);
	    text = $me.text();
      if ($(".jstthatid")[0]){
//            $me.parents(".selector-wrapper").find($selection).text(text).removeClass('show');
          $me.parents(".selector-wrapper").find("span.label span").text(text).removeClass('show');
		$me.parents(".selector-wrapper").find($prod_variants).val(value).trigger('change');
        setTimeout(function(){
          var bcd12=$(".selector-wrapper:eq(0)").find($prod_variants).val();
          var bcd122=$(".selector-wrapper:eq(1)").find($prod_variants).val();
          var bcd1222=bcd12+" / "+bcd122;
		handleThumbs(bcd1222);
          }, 300);
      }
      else{
	    $selection.text(text).removeClass('show');
		$prod_variants.val(value).trigger('change');
		handleThumbs(value);
      }
      $(".addItems").removeClass("added").text("Add to cart");
	}
    if ($(".template-product")[0] && $(window).outerWidth() < 782){
      $(".product-upper #product-images").css("visibility","hidden");
     $('.newimggallery').slick('unslick');
      $('#product-stage').find('.product-thumbs').slick('unslick');
      handleThumbs(value);
        var $thumbnailSlider = $('#product-stage').find('.product-thumbs.slick_slider');

  if($thumbnailSlider.length > 0  && $thumbnailSlider.data('mobile-only') == "1"){

    $('.product-slider.arrow').css('display','block');
//     $thumbnailSlider.slick({
//       prevArrow: $('.product-slider.arrow .flickity-prev-next-button.previous'),
//       nextArrow: $('.product-slider.arrow .flickity-prev-next-button.next'),
//       slidesToShow: 6,
//       slidesToScroll: 3,
//       centerMode: false,
//        asNavFor: '.newimggallery',
//       initialSlide: 0,
//       infinite: false,
//       slide: '.jstonit1'
//     });
    $thumbnailSlider.remove();
    
  }
  $(".newimggallery").slick({
    prevArrow: $('.product-slider1 .arrow .flickity-prev-next-button.previous'),
      nextArrow: $('.product-slider1 .arrow .flickity-prev-next-button.next'),
    initialSlide: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
    adaptiveHeight: true,
    slide: '.jstonit'
    });
      setTimeout(function(){
      $(".product-upper #product-images").css("visibility","visible");
        }, 300);
    }
    else if ($(window).outerWidth() < 989){
      var $thumbnailSlider = $('#product-stage').find('.product-thumbs.slick_slider');

      if ($thumbnailSlider.length > 0)
      {
        $thumbnailSlider.slick('slickGoTo', 0);
        var $slicktrack = $thumbnailSlider.find('.slick-track'); 
        $slicktrack.css('width','auto');

      }
    }
    $(".imgslst").css("display","none");
    var gtdtaval=$(".product-thumbs-item1.slick-slide.slick-current.slick-active").attr("data-alt");
  $(".imgslst[data-alt='"+gtdtaval+"']").css("display","block");
  });

  function handleThumbs(value) {
	if (!$thumbs.length) return;
	$thumbs.hide();
    if ($(".template-product")[0] && $(window).outerWidth() < 782){
     $thumbs1.hide();
    $thumbs1.removeClass("jstonit");
    $thumbs.removeClass("jstonit1");}
   
     if($(window).outerWidth() < 782){
         if(value == "Default Title"){
          $thumbs1.show();
           $thumbs1.addClass("jstonit");
         }
     }
     
	 if ($thumbs.filter('[data-alt="' + value + '"]').length > 1 || $thumbs1.filter('[data-alt="' + value + '"]').length > 1) {
		$thumbs.filter('[data-alt="' + value + '"]').show();
      $thumbs1.filter('[data-alt="' + value + '"]').show();
      
      if ($(".template-product")[0] && $(window).outerWidth() < 782){
        $thumbs1.filter('[data-alt="' + value + '"]').show();
      $thumbs1.filter('[data-alt="' + value + '"]').addClass("jstonit");
      $thumbs.filter('[data-alt="' + value + '"]').addClass("jstonit1");}
		$thumbs.filter('[data-alt="' + value + '"]').first().click();
	}
    else if ($thumbs.filter('[data-alt="' + value + '"]').length == 1 || $thumbs1.filter('[data-alt="' + value + '"]').length == 1){
    $thumbs1.filter('[data-alt="' + value + '"]').show();
      $thumbs1.filter('[data-alt="' + value + '"]').addClass("jstonit");
      $thumbs.filter('[data-alt="' + value + '"]').addClass("jstonit1");
    }
    else if(value == 'Default Title') {
      console.log("hideall22");
		$thumbs.show();
		$thumbs.first().click();
	}
    else{
      $thumbs1.show();
     $thumbs1.addClass("jstonit");
//     $thumbs.addClass("jstonit1");
    }
  }
  
  var $thumbnailSlider = $('#product-stage').find('.product-thumbs.slick_slider');

  if($thumbnailSlider.length > 0  && $thumbnailSlider.data('mobile-only') == "1" && $(window).outerWidth() < 989){

    $('.product-slider.arrow').css('display','block');
    if($(window).outerWidth() < 782){
//     $thumbnailSlider.slick({
//       prevArrow: $('.product-slider.arrow .flickity-prev-next-button.previous'),
//       nextArrow: $('.product-slider.arrow .flickity-prev-next-button.next'),
//       slidesToShow: 6,
//       slidesToScroll: 3,
//       centerMode: false,
//        asNavFor: '.newimggallery',
//       initialSlide: 0,
//       infinite: false,
//       slide: '.jstonit1'
//     });
      $thumbnailSlider.remove();
    }
    else{
    $thumbnailSlider.slick({
      prevArrow: $('.product-slider.arrow .flickity-prev-next-button.previous'),
      nextArrow: $('.product-slider.arrow .flickity-prev-next-button.next'),
      slidesToShow: 6,
      slidesToScroll: 3,
      centerMode: false, 
      initialSlide: 0,
      infinite: false,
    });
    }
  }
  if($(window).outerWidth() < 782){
  $(".newimggallery").slick({
    prevArrow: $('.product-slider1 .arrow .flickity-prev-next-button.previous'),
      nextArrow: $('.product-slider1 .arrow .flickity-prev-next-button.next'),
    initialSlide: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
    adaptiveHeight: true,
    slide: '.jstonit'
    });
  }
};

// Panels
theme.panels = function(){

	$('.trigger').click(function(){
		var $me = $(this),
			panel = $me.data('panel'),
			$panel = $('#'+panel),
			$panel_class = $('.'+panel);

		if (!$me.hasClass('active')){
			$me.addClass('active').siblings('.trigger').removeClass('active');

			device_exclude = (theme.cache.$win.width() > 782) ? '.mobile-only' : '.desktop-only';

			if($me.hasClass('mobile-c')){
				$('.mobile-panel').slideUp();
				$panel_class.not(device_exclude).slideDown().siblings('.panel').removeClass('show');
				setTimeout(function(){
					$panel_class.not(device_exclude).addClass('show');
				}, 150);
			} else {
				$panel.siblings('.panel').removeClass('show');
				$panel_class.siblings('.panel').removeClass('show');
				setTimeout(function(){
					$panel.addClass('show');
					$panel_class.addClass('show');
				}, 150);
			}
		}
      else{
        if($me.hasClass('mobileTab')){
          $me.removeClass('active');
          $panel.removeClass('show');
        }
      }
      
      if(panel == 'gallery'){
        setTimeout(function(){ 
          var $slick = $('.slick');

        if($slick.length > 0){
          $slick.slick('setPosition');
        }

                             }, 500);
      }
	});

	function calcPanelsWrap() {
		$('.panels-wrap').each(function() {
			var $wrap = $(this);
			var maxHeight = 0;
			$wrap.find('.panel').each(function() {
				var height = $(this).height();
				if (height > maxHeight) {
					maxHeight = height;
				}
			});
			$wrap.height(maxHeight);
		});
	}

	function updatePanelHeight() {
		var height = $('.panel.show', $metaPanels).outerHeight();
		$metaPanels.animate({height:height});
	}

	var $metaPanels = $('.product-meta-panels');

	$('.product-meta-panels').on('click', '.spr-summary-actions a', function() {
		updatePanelHeight();
	});

    $('#panel-reviews').bind("DOMSubtreeModified",function(){
      updatePanelHeight();
    });

	calcPanelsWrap();
	theme.cache.$win.on('resize', calcPanelsWrap);

};

// Horizontal scroll menus
theme.horizontalMenus = function(){

	// horizontal config menu controller
	// var $config_steps = $('#config-steps'),
	var $customize_header = $('.customize-header'),
	    $pmc = $('#product-meta-controller'),
	    // $config_steps_li = $config_steps.find('li'),
	    $customize_header_li = $customize_header.find('li'),
	    $pmc_li = $pmc.find('li');

	theme.initHorizMenus = function(){

		// var config_steps_total_width = 0
		var customize_header_total_width = 0,
			pmc_total_width = 0;

		//Config steps horizontal menu
		// if ($config_steps_li.length > 3 || theme.windowWidth() < theme.cache.mobile_break){
		// 	$config_steps_li.each(function(i,el){
		// 		config_steps_total_width = config_steps_total_width + $(el).outerWidth(true);
		// 	});
		// 	$config_steps.find('ul').width(config_steps_total_width + 20);
		// } else {
		// 	$config_steps_li.css('width', '33.33%');
		// 	$config_steps.find('ul').width('100%').closest('.horizontal-wrapper').addClass('three-options');
		// 	$('#config-steps').css('margin-right', '9%');
		// }

		// Customize header horizontal menu
		if ($customize_header_li.length > 2 || theme.windowWidth() < theme.cache.mobile_break){
			$customize_header_li.each(function(i,el){
				customize_header_total_width = customize_header_total_width + $(el).outerWidth(true);
			});
			$customize_header.find('ul').width(customize_header_total_width + 20);
		}

		// Product Meta panels horizontal menu
		if ($pmc_li.length > 4 || theme.windowWidth() < theme.cache.mobile_break){
			$pmc_li.each(function(i,el){
				pmc_total_width = pmc_total_width + $(el).width();
			});
			$pmc.find('ul').width(pmc_total_width);
		}
	}

	$('.trigger', $pmc).click(function(){
		var $me = $(this),
				me_panel = $me.data('panel');

		$('.product-meta-panels').animate({
			height: $('#'+me_panel).outerHeight(true)
		});
	})

	theme.initHorizMenus();
};

// Product Configurator
theme.configurator = function(){

	// init settings for the configurator
	var products_array = [],
	    product_price = 0,
	    ready = false;

	// loop through each configurable panel and determine if required options are fulfilled.
	// If a value has been selected for all required config options enable the product add to cart button
	function checkRequired(){

		// Look through each configurable option panel
		$('#config-stage .panel, [data-configurator-step]').each(function(i,el){

			var $swatch_wrap = $('.swatch-wrap, [data-swatch-set]', el);

			// if the current swatch wrap still has a class of 'fulfilled' a selection was made
			if ($swatch_wrap.hasClass('required')) {
				ready = $swatch_wrap.hasClass('fulfilled') ? 1 : 0;
			}
		});

		// set button state
		ready ? theme.cache.$addCustomProduct.removeClass('disabled') : $('.add-custom-product').addClass('');
	}

	function setOption($me){
		// the closest swatch wrap to the clicked swatch contains a bunch of data attributes for that product
		var $me_swatch_wrap = $me.closest('.swatch-wrap, [data-swatch-set]'),

				// This array-index attribute is used to populate the array of product variant id's that gets sumbitted to the cart (via ajax) when user is done building their product.
				// Need to keep track of the index of each product in the array so if user goes back and forth
				// through the configurator and makes changes the correct variant ID gets updated in the array
				selection_index = $me_swatch_wrap.data('array-index'),

				// This swatch-list attribute is used to connect the current list of swatches to the correct image overlay panel.
				// Name of data attribute matches the id name of the correlating image panel (standard stuff)
				// When a user selects a new swatch the variant image connected to that swatch will update the correct overlay panel in the live product preview.
				selection_img_wrap = $me_swatch_wrap.data('swatch-list'),

				// This img attribute contains the overlay image url for the selected swatch
				selection_img_src = $me.data('img'),

				// This swatch-partner attribute is used to connect the duplicated desktop and mobile swatch lists
				// Its unfortunate to have to do this but the mobile designs came after all this was built and the only way to
				// achieve the layout for both desktop and mobile was to duplicate elements.
				selection_partner = $me_swatch_wrap.data('swatch-partner'),

				// This price attribute is used to update and display the price as the product goes through the configurator steps.
				selection_price = $me.data('price'),

				// This variant-id attribute is used to populate the array of products that gets submitted to the cart when user is ready to build their product
				selection_variant = $me.data('variant-id'),

				// This title attribute has the name of the color in case we want to do something with it (like update the label over each swatch list with the name of the currently selected color)
				selection_title = $me.data('title'),

				$config_steps_items = $('.config-steps-item');

		// The mobile version has the swatches collapsed inside of an accordion panel. This handles the closing of the accordion when a color selection has been made.
		$me.closest('.acc-content').slideUp().prev('.acc-trigger').removeClass('open');

		// set step selector to a highlighted state
		$('#config-steps li').eq(selection_index).addClass('fulfilled');

		// If a selection has been made on a current config option add an indicating class on the swatch wrap and
		// and update the swatch list label with the name of the selected color variant
		$me_swatch_wrap.addClass('has-selection').prev('.label').find('.color-label').text(selection_title);
		$config_steps_items.filter('[data-swatch-list="' + selection_img_wrap +'"]').addClass('has-selection');

		// If a swatch has been selected give it an active class for the border indication and remove that class from any neighboring swatches
		$me.addClass('active').siblings('span').removeClass('active');

		// This updates the image in the live product preview with the newly selected variant img src that came from the swatches data-img attribute
		$('#'+selection_img_wrap).find('img').attr('src', selection_img_src);
console.log("herenow");
		// Add the newly selected variant id to the main product array. This is the array of product variants that gets submitted to the cart for build and purchase
		products_array[selection_index] = {
			id: selection_variant,
			price: selection_price
		};

		// Update price for each variant change
		setPrice();

		// If a selection has been made on a required option remove the class of 'required' and update to a class of 'fulfilled'
		// A product cannot be submitted to the cart unless all required options are fulfilled.
		// The check against this takes place in the checkRequired function and looks for the existance of the 'required' class
		if($me_swatch_wrap.hasClass('required')){
			$('[data-swatch-partner="'+selection_partner+'"]').addClass('fulfilled');
			$me_swatch_wrap.addClass('fulfilled');
		}

		// Each time a swatch has been selected run through the checkRequired function to see if the product is ready for build.
		checkRequired(selection_index, selection_variant);
	}

	function setPrice() {
		product_price = 0;
		for (var i in products_array) {
			if (products_array.hasOwnProperty(i)) {
				product_price += products_array[i].price;
			}
		}
		$('.update-price').text('€'+(product_price/100));
	}

	function unsetOption($me){
		var selection_variant = $me.data('variant-id'),
				$swatch_wrap = $me.closest('.swatch-wrap').removeClass('fulfilled'),
				selection_index = $swatch_wrap.data('array-index'),
				selection_img_wrap = $swatch_wrap.data('swatch-list'),
				selection_price = $swatch_wrap.data('price'),
				$img_wrap = $('#'+selection_img_wrap),
				$config_steps_item = $('.config-steps-item[data-swatch-list="' + selection_img_wrap +'"]');

		if ($img_wrap.index() === 0) {
			return false;
		}

		$('#config-steps li').eq(selection_index).removeClass('fulfilled');
		$me.removeClass('active');
		delete products_array[selection_index];

		$swatch_wrap.removeClass('has-selection').prev('.label').find('.color-label')
			.text($swatch_wrap.prev('.label').find('.color-label').data('default'));
		$config_steps_item.removeClass('has-selection');

		$('img',$img_wrap).removeAttr('src');

		setPrice();
		checkRequired();

		return false;
	}

	// Build array of products to call Shopify.queue
	function addCustomProductToCart() {
		var ajax_calls = [],
				len,
				i;

		$.each(products_array, function(i,el){
			if (typeof el != 'undefined') {
				Shopify.queue.push({
					variantId: products_array[i].id,
					quantity: 1
				});
			}
		});

		Shopify.moveAlong(function() {
			setTimeout(function() {
              if ($(".buynowcliked")[0]){
                setTimeout(function(){
                
                 window.location.href = "/checkout";
           
                  }, 1500);
              }
              else{
                lemonade.openCartTemporary();}
			});
		});
		resetBuilder();
	}

	function resetBuilder() {
		theme.cache.$addCustomProduct.addClass('disabled').text("Translation missing: en.products.product.added_to_cart");
		products_array = [];
	}

	function init(){
		// First variant of the first product should always be the starting point
		var $starting_panel = $('.config-stage-left .panel').first().find('.swatch-wrap'),
				product_price = $starting_panel.data('price');

		// Do a check right off the bat in case the configurator has no required options
		// This will make the add to cart button accessibile without an initial click of a swatch.
		// The first swatch of the first panel will always be selected by default.
		checkRequired();

		// Build the preview image as user selects colors.
		// Each click of an option will fire checkRequired() function to see if the product is ready for add to cart.
		$('.color-swatches .swatch').click(function(){
			var $me = $(this),
					$label = $me.closest('.color-swatches').find('.label');

			if (!$me.hasClass('active')) {
				$label.addClass('active');
				setOption($me);
			} else {
				$label.removeClass('active');
				unsetOption($me);
			}
		});

		theme.cache.$addCustomProduct.click( addCustomProductToCart );

		$('.color-swatches .remove').click(function(){
			$(this).closest('.color-swatches').find('.swatch.active').click();
		});

		$('.swatch', $starting_panel).eq(0).click();

		setPrice();
	}

	init();
};


theme.configuratorV2 = function () {

  var debug = DEBUG ? console.log.bind(console, '[ConfiguratorV2]') : function () {};
  var error = console.error.bind(console, '[ConfiguratorV2]');

  // init settings for the configurator
  var $configurator = null;
  var $previewImage = null;
  var $previewImageViews = null;
  var $preview3D = null;

  var options = null;
  var productsArray = [];
  var productPrice = 0;
  var ready = false;
  var currentView = 'default';
  var currentPreviewMode = '2d';
  var steps = [];

  var templateFileURL = '//bloombaby.eu/cdn/shop/files/FILENAME?v=4982';
  var templateAssetURL = '//bloombaby.eu/cdn/shop/t/21/assets/FILENAME?v=4982';

  var selectedOptions = {};


  function updatePrice() {
		productPrice = 0;

    var totalPrice = productsArray.reduce(function (result, product) {
     result=result + product.price;
      return result;
    }, 0);
		$('[data-configurator-price]').text('€'+(totalPrice/100));
    
    var bcd3='<p class="affirm-as-low-as configurator-v2__product-mobile-bar__pricing-price" data-page-type="cart" data-amount="'+totalPrice+'"></p>';
    $(".newafrm").html(bcd3);
    
    _affirm_config = {
				public_api_key: "B4UZQTZ6FFM7Q0QQ",
				script: "https://cdn1.affirm.com/js/v2/affirm.js"
			};
			(function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
			
    
    if(totalPrice >= 10000){$(".configurator-v2__freeShipping").show()}else{$(".configurator-v2__freeShipping").hide()}
	}

  function getProductImage(productHandle, view) {
    view = view || currentView;

    var image = $('[data-view="' + view + '"] [data-product-handle="' + productHandle + '"]').find('img');

    return image;
  }

  
    function setImage(productHandle, imageData, view) {
    debug('Set image', productHandle, 'with image', imageData);
    var $image = getProductImage(productHandle, view);

    if (imageData.valid) {

      var sameVariant = $image.attr('data-image-variant-id') == imageData.variant_id;
      var validSource = $image.attr('src');

      if (!sameVariant || !validSource) {
        $image.removeClass('lazyloaded')
          .attr('data-image-variant-id', imageData.variant_id)
          .addClass('lazyload')
          .removeClass('lazyloaded')
          .removeAttr('src')
          .removeAttr('srcset')
          .attr('data-sizes', 'auto')
          .attr('data-src', imageData.src)
          .attr('data-srcset', imageData.srcset);
        ;

        $image.show();
//         console.log("yes iam");
      }



    }
  }

  function unsetImage(productHandle, view) {
    var $image = getProductImage(productHandle, view);

    $image
      .removeClass('lazyloaded')
      .removeAttr('src')
      .removeAttr('srcset')
      .removeAttr('data-src')
      .removeAttr('data-srcset')
      .hide();
    ;
  }
  

  function updateControls() {
    setTimeout(function () {
      var $swatches = $configurator.find('[data-swatch-set]');
      var $unfulfilledRequiredSwatches = $swatches.filter('.required').not('.fulfilled');

      debug('We have', $unfulfilledRequiredSwatches, 'unfulfilled');
      $configurator.find('[data-add-to-cart]').toggleClass('enabled', $unfulfilledRequiredSwatches.length == 0);
   $configurator.find('.enabled[data-add-to-cart] span').text("ADD TO CART");
    }, 20);
  }

  function variantHasImageForView(productHandle, variantId, view) {
    var imageData = getImageForView(productHandle, variantId, view);
    return imageData.valid && !imageData.empty;
  }

  function selectOption($option) {
    debug('Selected option "' + $option.data('title') + '"');

		// the closest swatch wrap to the clicked swatch contains a bunch of data attributes for that product
		var $optionSwatchSet = $option.closest('[data-swatch-set]'),

				// This array-index attribute is used to populate the array of product variant id's that gets sumbitted to the cart (via ajax) when user is done building their product.
				// Need to keep track of the index of each product in the array so if user goes back and forth
				// through the configurator and makes changes the correct variant ID gets updated in the array
				selectionIndex = $optionSwatchSet.data('array-index'),

				// This img attribute contains the overlay image url for the selected swatch
				selectionImgSrc = $option.data('img'),

				// This swatch-partner attribute is used to connect the duplicated desktop and mobile swatch lists
				// Its unfortunate to have to do this but the mobile designs came after all this was built and the only way to
				// achieve the layout for both desktop and mobile was to duplicate elements.
				selectionPartner = $optionSwatchSet.data('swatch-partner'),

				// This price attribute is used to update and display the price as the product goes through the configurator steps.
				selectionPrice = $option.data('price'),

				// This variant-id attribute is used to populate the array of products that gets submitted to the cart when user is ready to build their product
				selectionVariant = $option.data('variant-id'),

				// This title attribute has the name of the color in case we want to do something with it (like update the label over each swatch list with the name of the currently selected color)
				selectionTitle = $option.data('title'),

            $configuratorStep = $optionSwatchSet.closest('[data-configurator-step]'),

            $noneOptionSwatch = $optionSwatchSet.find('[data-swatch="remove"]'),

            $selectOptionSwatch = $optionSwatchSet.find('[data-swatch="select"]')
    ;

    var productHandle = $optionSwatchSet.data('product-handle');

		// If a selection has been made on a current config option add an indicating class on the swatch wrap and
		// and update the swatch list label with the name of the selected color variant
		$optionSwatchSet.addClass('has-selection').prev('.label').find('.color-label')

    $configuratorStep.find('[data-configurator-step-value]').text(selectionTitle);

    $configuratorStep.addClass('has-selection').addClass('fulfilled');

		// If a swatch has been selected give it an active class for the border indication and remove that class from any neighboring swatches
    $optionSwatchSet.find('[data-swatch]').removeClass('selected');
		$option.addClass('selected');

    selectedOptions[productHandle] = selectionVariant;
//alert("/"+$.trim($(".configurator-v2__product-title").html()+"/");
    console.log(selectionPartner);
    if (selectionPartner == "fresco-wooly-seat-liner-partner") {
      $previewImageViews.slick('slickGoTo', 4);
    }
    else if(selectionPartner == "toy-bar-test-partner"){
      if ($(".page-new-fresco-highchair")[0] || $(".page-coco-go-3-in-1-bouncer")[0]){
    $previewImageViews.slick('slickGoTo', 1);
      }
    }
     else if(selectionPartner == "fresco-mat-and-bowl-set-partner"){
      if ($(".page-new-fresco-highchair")[0] || $(".page-coco-go-3-in-1-bouncer")[0]){
    $previewImageViews.slick('slickGoTo', 6);
      }
       else if ($(".page-fresco-highchair")[0]){
       $previewImageViews.slick('slickGoTo', 0);
       }
    }
    else if(selectionPartner == "coco-wooly-seat-pad-liner-partner"){
      
    $previewImageViews.slick('slickGoTo', 0);
    }
    else if ($(".page-fresco-highchair")[0] && selectionPartner == "universal-baby-snug-partner"){
    $previewImageViews.slick('slickGoTo', 3);
    }
    else if ($(".page-fresco-highchair")[0] && selectionPartner == "fresco-baby-highchair-wooly-seat-liner-partner"){
    $previewImageViews.slick('slickGoTo', 2);
    }
    else if ($(".page-fresco-highchair")[0] && selectionPartner == "universal-baby-snug"){
    $previewImageViews.slick('slickGoTo', 5);
    }
     else if ($(".page-fresco-highchair")[0] && selectionPartner == "fresco-de-luxe-seat-liner-partner"){
    $previewImageViews.slick('slickGoTo', 4);
    }
    else if($(".page-fresco-highchair")[0] && selectionPartner == "chow-feeding-bundle-partner"){
     $previewImageViews.slick('slickGoTo', 1);   
    }
    else if ($previewImageViews.children().length > 1 && !variantHasImageForView(productHandle, selectionVariant, currentView)) {
      $previewImageViews.slick('slickGoTo', 0);
      
    }
    else if($(".page-coco-go-3-in-1-bouncer")[0] && selectionPartner == "coco-coco-go-de-luxe-seat-liner-partner"){
     $previewImageViews.slick('slickGoTo', 1);
    }
    
    
    updateView();
    updateControls();

    if ($option.data('swatch') == 'remove') {
      productsArray[selectionIndex] = null;
    } else {
      // Add the newly selected variant id to the main product array. This is the array of product variants that gets submitted to the cart for build and purchase
      productsArray[selectionIndex] = {
        id: selectionVariant,
        price: selectionPrice
      };

    }

		// Update price for each variant change
		updatePrice();

		// If a selection has been made on a required option remove the class of 'required' and update to a class of 'fulfilled'
		// A product cannot be submitted to the cart unless all required options are fulfilled.
		// The check against this takes place in the checkRequired function and looks for the existance of the 'required' class
		if($optionSwatchSet.hasClass('required')){
			$optionSwatchSet.addClass('fulfilled');
		}
	}

  /**
   * Unselect an option
   */
  function unselectOption($option) {
    debug('Unselected option "' + $option.data('title') + '"');

		var selectionVariant = $option.data('variant-id'),
				$swatchSet = $option.closest('[data-swatch-set]').removeClass('fulfilled'),
				selectionIndex = $swatchSet.data('array-index'),
				selectionPrice = $swatchSet.data('price'),
				$configuratorStep = $swatchSet.closest('[data-configurator-step]'),
        $noneOptionSwatch = $swatchSet.find('[data-swatch="remove"]');

    var productHandle = $swatchSet.data('product-handle');

    selectedOptions[productHandle] = false;

		$option.removeClass('selected');
    $noneOptionSwatch.addClass('selected');
		delete productsArray[selectionIndex];

    $configuratorStep.removeClass('has-selection');

    $configuratorStep.find('[data-configurator-step-value]').text($swatchSet.data('default'));


    updateView();
    updateControls();

		updatePrice();

		return false;
	}

  /**
   * Build array of products to call Shopify.queue
   */
	function addCustomProductToCart() {
		var ajaxCalls = [],
				len,
				i;

		$.each(productsArray, function(i, el) {
			if (typeof el != 'undefined') {
				Shopify.queue.push({
					variantId: productsArray[i].id,
					quantity: 1
				});
			}
		});

		Shopify.moveAlong(function() {
			setTimeout(function() {
               if ($(".buynowcliked")[0]){
                setTimeout(function(){
               
                 window.location.href = "/checkout";
             
                   }, 1500);
              }
              else{
                lemonade.openCartTemporary();}
			});
		});

		resetBuilder();
	}


  /**
   * Reset the builder
   */
  function resetBuilder() {
		theme.cache.$addCustomProduct.removeClass('enabled').text("Translation missing: en.products.product.added_to_cart");
		productsArray = [];
	}

  function handle(string) {
    return string.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\_\-]+/g, '');
  }

  function processImage(options, image, variantsByHandle, product) {
    image.alt_fields = image.alt_fields.reduce(function (allFields, current) {
      var parts = current.split('=');
      var key = parts[0].trim().toLowerCase();
      var value = (parts[1] || key).trim();

      allFields[key] = value;

      return allFields;
    }, {});

    if (image.alt_fields.view) {
      image.view = image.alt_fields.view;

      options.viewsDict[image.view] = true;
    }

    if (image.alt_fields.variant) {

      var variantName = image.alt_fields.variant;

      image.variant_handle = handle(variantName);

      try {
        var variant = variantsByHandle[image.variant_handle]
        options.imagesByVariantId[variant.id].push(image);
      } catch (e) {
        error('[MultipleViews]',
          'Could not get variant "' + variantName + '" for product "' + product.title + '".',
          'Available variants are: "' + Object.values(variantsByHandle).map(function (v) { return v.title; }).join('", "') + '".'
        );
      }

    }
  }

  function processOptions(options) {
    debug('Process options', options);

    options.productsById = {};
    options.productsByHandle = {};
    options.variantsById = {};
    options.imagesByVariantId = {};
    options.views = [];
    options.viewsDict = {};

    options.products.forEach(function (product) {
      var variantsByHandle = {};

      product.variants.forEach(function (variant) {
        options.variantsById[variant.id] = variant;
        options.imagesByVariantId[variant.id] = [];
        variantsByHandle[handle(variant.title)] = variant;
      });

      product.images.forEach(function (image) {
        processImage(options, image, variantsByHandle, product);
      });




      options.productsById[product.id] = product;
      options.productsByHandle[product.handle] = product;
    });

    options.views = Object.keys(options.viewsDict);

    return options;
  }

  function isComposite(product) {
    return product.tags.indexOf('composite') != -1;
  }

  function getImageForView(productHandle, variantId, view) {
    var product = options.productsByHandle[productHandle];
    var images = options.imagesByVariantId[variantId];
   var variantid12=variantId;
    
    var image = images.filter(function (i) { return i.view == view; })[0];
//  console.log(image.src);
    //debug('getImageForView', { product, images, image, view });

    if (image) {
//       console.log("here now");
      var src = isComposite(product) ? image.src_cropped : image.src;
      var srcMobile = isComposite(product) ? image.src_cropped_mobile : image.src_mobile;
      var srcLarge = isComposite(product) ? image.src_cropped_large : image.src_large;

      var srcset = [
          [ srcMobile, '300w' ],
          [ src, '600w' ],
          [ srcLarge, '1024w' ]
        ]
        .filter(function (row) { return row && row[0]; })
        .map(function (row) { return row.join(' '); })
        .join(', ')
      ;

      return {
        valid: true,
        empty: false,
        variant_id: variantId,
        src: src,
        srcset: srcset
      };

    } else {
//       console.log(view);
      return {
        valid: true,
        empty: true,
        variant_id: variantId,
        src: '',
        srcset: ''
      };

    }
  }


  function updateAll2DViews() {
    options.views.forEach(update2DView);
  }


  function update2DView(view) {
    view = view || currentView;
    debug('Update view', view, options.imagesByVariantId);

    Object.keys(selectedOptions).forEach(function (productHandle) {
      var variantId = selectedOptions[productHandle];
      if (variantId) {
              var bcd1=$("body").attr("id");
        if( (bcd1 == "page-new-fresco-highchair" || bcd1 == "page-fresco-highchair") && (view == "upright" || view == "semi" || view == "reclined" || view == "folded" || view == "coco close up") )
        {
//        unsetImage(productHandle, view);
         $(".hereis.configurator-v2__preview-image-view[data-view="+view+"]").addClass("nothsone");
//           setImage(productHandle, getImageForView(productHandle, variantId, view), view);
        }
        else if( (bcd1 == "coco-go-3-in-1-bouncer") && (view == "complete" || view == "highchair" || view == "front" || view == "toddler" || view == "newborn" || view == "closeup") )
        {
        unsetImage(productHandle, view);
          $(".hereis.configurator-v2__preview-image-view[data-view="+view+"]").addClass("nothsone");
        }
        else{
        setImage(productHandle, getImageForView(productHandle, variantId, view), view);
          $(".hereis.configurator-v2__preview-image-view[data-view="+view+"]").addClass("onlythsone");
        }
      } else {
        
        unsetImage(productHandle, view);
      }
    });
  }

  function setView(view) {
    currentView = view;
    debug('Changed to view', currentView);
  }

  function initializeViews() {
    $previewImage = $configurator.find('[data-preview-image]');
    $previewImageViews = $previewImage.find('[data-preview-image-views]');
    $templateView = $previewImageViews.find('[data-preview-image-view]');

    if (options.views.length >= 2) {

      options.views.forEach(function (view) {
        var $view = $templateView.clone();
        $view.attr('data-view', view);
        console.log(view);
                      var bcd21=$("body").attr("id");
        if( (bcd21 == "page-new-fresco-highchair" || bcd21 == "page-fresco-highchair") && (view == "upright" || view == "semi" || view == "reclined" || view == "folded" || view == "coco close up") )
        {

        }
        else if( (bcd21 == "page-coco-go-3-in-1-bouncer") && (view == "middle" || view == "complete" || view == "highchair" || view == "front" || view == "toddler" || view == "newborn" || view == "closeup") )
        {

        }
        else if( (bcd21 == "page-alma-grow-crib") && (view == "minibassinet" || view == "minicloseup" || view == "papabassinet" || view == "papacloseup" || view == "maxbassinet" || view == "maxcloseup") )
        {
          
        }
        else if( (bcd21 == "page-alma-mini-crib") && (view == "growbassinet" || view == "growcloseup" || view == "papabassinet" || view == "papacloseup" || view == "maxbassinet" || view == "maxcloseup") )
        {
          
        }
        else if( (bcd21 == "page-alma-papa-convertible-folding-crib") && (view == "growbassinet" || view == "growcloseup" || view == "minibassinet" || view == "minicloseup" || view == "maxbassinet" || view == "maxcloseup") )
        {
          
        }
        else if( (bcd21 == "page-alma-max-standard-convertible-crib") && (view == "growbassinet" || view == "growcloseup" || view == "minibassinet" || view == "minicloseup" || view == "papabassinet" || view == "papacloseup") )
        {
          
        }
        else{
//           console.log($view);
   $previewImageViews.append($view);
        }
        
      });

      $templateView.remove()

//        var imgIsEmpty = false;
//       $(".configurator-v2__preview-image-view" ).each(function() {
//         imgIsEmpty = false;
//         if($(this).find('.overlay-img').first().find("img").attr('data-srcset')){
//           imgIsEmpty = true;          
//         }
//         if(imgIsEmpty){
//           $(this).addClass("EmptyCss2");
//         }
//         console.log($(this).find('.overlay-img:eq(0) img').attr('data-srcset'));
//       });
       var bcd211=$("body").attr("id");
        if(bcd211 == "page-new-fresco-highchair" || bcd211 == "page-coco-go-3-in-1-bouncer")
           {
           $previewImageViews.slick({
        dots: false,
        "arrows": true,
        "nextArrow": "[data-configurator-next-view]",
        "prevArrow": "[data-configurator-prev-view]",
        autoplay: false,
        infinite: false
      });
           }
           else{
      $previewImageViews.slick({
        dots: true,
        "arrows": true,
        "nextArrow": "[data-configurator-next-view]",
        "prevArrow": "[data-configurator-prev-view]",
        autoplay: false,
        infinite: false
      });
    }

//       var imgIsEmpty = false;
//       $(".configurator-v2__preview-image-view" ).each(function() {
//         imgIsEmpty = false;
//         $(this).find('.overlay-img img').each(function() {
//           if($(this).attr('data-src') || $(this).attr('data-src') == false){
//             imgIsEmpty = true;
//           }else{imgIsEmpty = false;}
//         });
//         if(imgIsEmpty){
//           $(this).addClass("EmptyCss");
//         }
          
//       });
      
     
      

      $previewImageViews.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var nextView = options.views[nextSlide];
        update2DView(nextView);
      });

      $previewImageViews.on('afterChange', function (event, slick, currentSlide) {
        setView(options.views[currentSlide]);
      });

      currentView = options.views[0];

    } else {
      currentView = 'default';
      $templateView.attr('data-view', options.views[0] || 'default');

    }
  }

  function on3DLoaded() {

  }

  function get3DFilePath() {
    var filename = steps.map(function (step) {
      return selectedOptions[step] ? options.variantsById[selectedOptions[step]].sku : 'NONE';
    }).join('_') + '.glb';

    var path = templateFileURL.replace('FILENAME', filename);
    return path;
  }

  function get3DTestFilePath() {
    return templateAssetURL.replace('FILENAME', '3dviewer.test.glb');
  }

  function update3DView() {
    //var path = get3DTestFilePath();
    var path = get3DFilePath();

    $preview3D.find('.error').fadeOut();
    $preview3D.find('.loading').fadeIn();

    bloom3DViewer.load(path, function () {
      $preview3D.find('.loading').fadeOut();

    }, function (e) {
      $preview3D.find('.loading').fadeOut();
      $preview3D.find('.error')
        .text('3D View not available')
        .fadeIn()
      ;

    });
  }

  function setPreviewMode(mode) {
    currentPreviewMode = mode;
    $configurator.find('[data-preview-selector]').removeClass('active');
    $configurator.find('[data-preview-selector="' + mode + '"]').addClass('active');
    if (currentPreviewMode == '3d') {
      update3DView();
      $preview3D.fadeIn();
      $previewImage.fadeOut();
    } else {
      bloom3DViewer.stop();
      $previewImage.fadeIn();
      update2DView();
      $preview3D.fadeOut();
    }
  }

  function updateView() {
    if (currentPreviewMode == '3d') {
      update3DView();
    } else {
      updateAll2DViews();
    }
  }


  function onResize() {
    if ($previewImageViews.is('.slick-slider')) {
      var parentHeight = $previewImageViews.parent().innerHeight();
      $previewImageViews.find('.slick-slide').height(parentHeight);

      $previewImageViews.slick('resize');
    }
  }

  /**
   * Initialize configurator
   */
  function initialize() {

    $configurator = $('[data-configurator]');
    steps = $configurator.find('[data-configurator-step]').map(function () { return $(this).data('configurator-step'); }).toArray();


    $(window).resize(onResize);



    $previewImage = $configurator.find('[data-preview-image]');
    $preview3D = $configurator.find('[data-preview-3d]');
    options = processOptions($configurator.data('configurator'));
    initializeViews();

		// First variant of the first product should always be the starting point
		var $firstStep = $('[data-swatch-set]').first(),
				productPrice = $firstStep.data('price');

    $('[data-preview-selector]').click(function () {
      setPreviewMode($(this).data('preview-selector'));
    });

		// Build the preview image as user selects colors.
		// Each click of an option will fire checkRequired() function to see if the product is ready for add to cart.
		$('[data-swatch="select-color"], [data-swatch="select"]').click(function(){
			var $option = $(this);
          var $option23=$option.attr("data-product-handle");
		  var $label = $option.closest('[data-configurator-step]').find('[data-configurator-step-value]');

			if (!$option.hasClass('selected')) {
				$label.addClass('selected');
				selectOption($option);
               $("p."+$option23+" .fa.fa-check").css("display", "inline-block");
    $("p."+$option23+" .fa.fa-times").css("display", "none");
			} else {
        if (!$option.data('required')) {
          $label.removeClass('selected');
          unselectOption($option);
           $("p."+$option23+" .fa.fa-check").css("display", "none");
    $("p."+$option23+" .fa.fa-times").css("display", "inline-block");

          /*
          var $optionSet = $option.closest('[data-swatch-set]');
          var $removeOption = $optionSet.find('[data-swatch="remove"]');
          $removeOption.click();
          */
        }
			}
		});

		theme.cache.$addCustomProduct.click( addCustomProductToCart );

		$('[data-swatch="remove"]').click(function() {
      var $swatchSet = $(this).closest('[data-swatch-set]');
      var productHandle = $swatchSet.data('product-handle');

      if (selectedOptions[productHandle]) {
        $swatchSet.find('[data-swatch].selected').click();
      }

      //selectOption($(this));
		});

    var $firstOption = $firstStep.find('[data-swatch]:first-child');
    selectOption($firstOption);

		updatePrice();
	}

  if ($('[data-configurator]').length >= 1) {
    initialize();
  }
    
    /*var imgIsEmpty = false;
    $(".configurator-v2__preview-image-view" ).each(function() {
      imgIsEmpty = false;
      if(!$(this).find('.overlay-img img').first().attr('data-src')){
        imgIsEmpty = true;
      }
      if(imgIsEmpty){
        $(this).remove();
      }
    });
    if($configurator != null){
    $previewImage = $configurator.find('[data-preview-image]');
    $previewImageViews = $previewImage.find('[data-preview-image-views]');
    //$previewImageViews.slick.refresh();
    $previewImageViews.slick('setOption', {}, true); 
    }*/
};


// Get cart and load cart flyout
// theme.loadCart = function(callback){
// 	$.getJSON('/cart.js', function(cart) {
// 		// empty items to rebuild
// 		theme.cache.$flyout_items.empty();

// 		// Update cart count in header
// 		$('.cart-count').text(cart.item_count);

// 		// Build newly added items in the mini cart
// 		var moneyFormat = '';
// 		theme.cache.$flyout.find('.empty-cart').remove();
// 		theme.cache.$flyout.find('.cart-footer').removeClass('hide').find('.cart-total-price').text(Shopify.formatMoney(cart.total_price).replace('.00',''));

// 		$.each(cart.items, function(i,item){
// 			var price = Shopify.formatMoney(item.price, moneyFormat).replace('.00', '');
//       		theme.cache.$flyout_items.prepend('<div class="cart-item"><div class="c-col c-item mh"><img src="'+item.image+'" /></div><div class="c-col c-deets mh"><div class="cart-inner"><h3>'+item.product_title+'</h3></div></div><div class="c-col c-qty mh"><input type="number" class="cart__quantity-selector" name="updates[]" id="updates_'+item.id+'" value="'+item.quantity+'" min="0" aria-label="Quantity" /></div><div class="c-col c-price mh"><span>'+price+'</span></div><div class="c-col c-remove mh"><span class="remove-item"><a href="/cart/change?line=2&quantity=0" class="cart__remove"><span class="icon icon-close"><svg><use xlink:href="#icon-close"></use></svg></span></span></div></div>');
// 		});

// 		if (typeof callback === 'function') {
// 			callback();
// 		}
// 	});
// }

// Instagram Feed
theme.instagram = function(){

  var $target = $("#instafeed");

  $target.instagramLite({
    clientID: $target.data('client-id'),
    urls: true,
    videos: true,
    limit: $target.data('count'),
    error: function(errorCode, errorMessage) {
      if(errorCode && errorMessage) {
        alert(errorCode +': '+ errorMessage);
      }
    }
  });

};

// media block
theme.mediaBlock = function(){
	var $media_block = $('.media-block');

	if($media_block.has('blockquote').length > 0){
		$media_block.addClass('pullquote').find('blockquote').next().css('margin-top', 120);
	} else if($media_block.has('iframe').length > 0){
		$media_block.addClass('video');
	}
}

theme.collectionAnchors = function(){
	$('.billboard-text .anchor').click(function(){
		var $me = $(this),
				anchor = $me.attr('data-anchor');

		theme.cache.$body.animate({'scrollTop': $('.collection-wrapper:eq(0)').position().top - 50});
	});
}

// Initialize theme JS on docready
$(theme.init);



/**
 * Custom scripts
 */

if (DEBUG) {

  function reloadStylesheets() {
    console.log('[DEBUG] Styles have been reloaded');
    var queryString = '?' + new Date().getTime();
    $('link[rel="stylesheet"]').each(function () {
      if (this.href.indexOf('app.scss.css') != -1) {
        this.href = this.href.replace(/\?.*|$/, queryString);
      }
    });
  }

  function setStylesReloader() {
    setInterval(reloadStylesheets, 4000);
  }

}

$(function () {

  var noop = function () {};
  var debug = DEBUG ? console.log.bind(console, '[CartManager]') : noop;

  self = {
    queue: [],
    callback: noop
  };

  self.asItemPayload = function (itemOrVariantId) {
    if (typeof itemOrVariantId == 'object') {
      return Object.assign({ quantity: 1 }, itemOrVariantId);
    } else {
      return { id: itemOrVariantId, quantity: 1 };
    }
  }

  self._addItem = function (item) {
    self.queue.push(self.asItemPayload(item));
  };

  self.addItem = function (item, callback) {
    self._addItem(item);
    self.processQueue(callback);
  };

  self.addItems = function (items, callback) {
    items.forEach(function (item) {
      self._addItem(item);
    });
    self.processQueue(callback);
  };


  self._addToCart = function (item) {
    return $.post('/cart/add.js', item, null, 'json')
      .done(function (response) {
        debug('Item added to cart.', item);
        return response;
      })
      .fail(function (e, message) {
        console.error('[CartManager]', 'Failed to add item to cart:', JSON.stringify(item));
        console.error('[CartManager]', 'Error:', JSON.stringify(e));
      });
  };

  self._runCallbacks = function () {
    self.callback();
    self.callback = noop;
  };

  self._processQueue = function () {
    if (self.queue.length >= 1) {
      var item = self.queue.pop();
      return self._addToCart(item).then(function () {
        return self._processQueue();
      });
    } else {
      self._runCallbacks();
      return $.Deferred().resolve().promise();
    }
  };

  self.processQueue = function(callback) {
    self.callback = callback;
    return self._processQueue();
  };

  window.CartManager = self;

});


/**
 * Upsells
 */


$(function () {

  var debug = DEBUG ? console.log.bind(console, '[DEBUG][BloomUpsells]') : function () {};

  var self = {
    options : {},
    $popup : null,
    visible: false,
    $closeButton : null,
    $updateButton : null,
    callback : null,
    ready: false,

    selectedOptions : {}
  };

  self.setLoading = function (value) {
    self.$popup.toggleClass('loading', value);
  };

  self.updateCart = function () {
    var variantIds = Object.values(self.selectedOptions).filter(function (v) { return v; });

    if (variantIds.length >= 1) {

      debug('Update cart');
      self.setLoading(true);

      CartManager.addItems(variantIds, function () {
        self.setLoading(false);
        self.close();
      });

    } else {
      self.close();
      debug('Ignoring update, no items selected');

    }
  };


  self.isVisible = function () {
    return self.$popup.hasClass('active');
  };


  self.runCallback = function () {

    if (self.callback) {
      self.callback();
      self.callback = null;
    }

  };


  self.close = function () {
    if (self.ready && self.isVisible()) {
      $('body').removeClass('no-scroll');
      self.$popup.removeClass('active');
      self.runCallback();
      debug('Closed');
    }
  };


  self.show = function (callback) {
    if (self.ready && !self.isVisible()) {
      self.callback = callback;
      $('body').addClass('no-scroll');
      self.$popup.addClass('active');
      debug('Shown');
    }
  };


  self.getVariant = function (variantId) {
    return self.options.variants[variantId] || { price: 0 };
  };


  self.updatePrice = function() {
    var totalPrice = Object.values(self.selectedOptions).reduce(function (result, variantId) {
      return result + self.getVariant(variantId).price;
    }, 0);

    self.$price.text('€'+(totalPrice/100));
   
  };


  self.clearOption = function ($option) {
    debug('Clear option');
    $allOptions = $option.closest('[data-swatch-set]').find('[data-swatch]');
    $allOptions.removeClass('selected');

    delete self.selectedOptions[$option.data('product-handle')];
    self.updatePrice();
    
  };


  self.unselectOption = function ($option) {
    $option.removeClass('selected');

    delete self.selectedOptions[$option.data('product-handle')];

    self.updatePrice();
    
  };


  self.selectOption = function ($option) {
    $allOptions = $option.closest('[data-swatch-set]').find('[data-swatch]');

    $allOptions.removeClass('selected');
    $option.addClass('selected');

    self.selectedOptions[$option.data('product-handle')] = $option.data('variant-id');

    self.updatePrice();
  };


  self.initialize = function () {

    self.$popup = $('[data-bloom-upsells]');

    if (self.$popup.length >= 1) {
      self.ready = true;

      Object.assign(self.options, self.$popup.data('bloom-upsells'));

      self.$price = self.$popup.find('[data-bloom-upsells-price]');
      debug('Price', self.$price);

      self.$closeButton = self.$popup.find('[data-bloom-upsells-close]');
      self.$updateButton = self.$popup.find('[data-bloom-upsells-update]');

      self.$popup.find('[data-swatch]').click(function () {
        var $option = $(this);
        var type = $option.data('swatch');

        if (type == 'remove') {
          self.clearOption($option);
        } else {
          if ($option.hasClass('selected')) {
            self.unselectOption($option);
          } else {
            self.selectOption($option);
          }
        }
      });

      debug(self.$closeButton, self.$updateButton);

      self.$closeButton.click(function () {
        self.close();
      });
      self.$updateButton.click(function () {
        self.updateCart();
      });

      debug('Initialized');

    }

  };


  window.BloomUpsells = self;

  self.initialize();

});



/**
 * Reviews Proxy
 *
 * Replicate review stars and count from Shopify Product Review widget to other
 * spots on the page.
 */

$(function () {

  var debug = DEBUG ? console.log.bind(console, '[DEBUG]') : function () {};

  function reviewsLoaded() {
    return $('#shopify-product-reviews .spr-container').length >= 1;
  }

  function getReviewsCount() {
    return parseInt($('#shopify-product-reviews .spr-summary-actions-togglereviews').text().replace(/[^0-9]+/g, ''));
  }

  function getStars() {
    return $('#shopify-product-reviews .spr-starrating.spr-summary-starrating').children('.spr-icon-star').length;
  }


  function _init() {
    var $proxies = $('[data-reviews-proxy]');

    $proxies.each(function () {

      var $proxy = $(this);

      var reviewsCount = getReviewsCount();

      if (reviewsCount >= 1) {

        $proxy.find('[data-reviews-proxy-label]').text(reviewsCount == 1 ? 'Review' : 'Reviews');

        $proxy.find('[data-reviews-proxy-filled-state]').fadeIn();

        $proxy.find('[data-reviews-proxy-count]').text(reviewsCount);

        var $stars = $proxy.find('[data-reviews-stars]');

        var stars = getStars();

        $stars.children().each(function (i) {
          var $star = $(this);
          $star.toggleClass('filled', i < stars);
        });

      } else {
        $proxy.find('[data-reviews-proxy-empty-state]').fadeIn();

      }

    });

    debug('Reviews proxy initialized');
  }

  function init() {
    if (reviewsLoaded()) {
      _init();
    } else {
      setTimeout(init, 500);
    }
  }

  init();
});

$('.slider-wrap-image-wraper.slider-for-mobile .arrow-prev').click(function(){
    $(".slider-wrap-image-wraper.slider-for-mobile .slick").slick('slickPrev');
});
$('.slider-wrap-image-wraper.slider-for-mobile .arrow-next').click(function(){
    $(".slider-wrap-image-wraper.slider-for-mobile .slick").slick('slickNext');
});
  
$(document).on('click', 'a.collection-review[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 1000);
});